// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 500px) {
    .scl--jcbst-hea-bo-st{
        height: auto;
        padding-bottom: 50px;
        margin-top: 120px;
    }

    .scl--jhhs-des-sty h5{
        font-size: 34px;
        display: flex;
        align-items: center;
        min-height: 70px;
    }

    .scl--jhbs-her-hea-st{
        flex-direction: column;
        gap: 30px;
    }

    .scl--jhhs-but-sty{
        width: 100%;
        justify-content: center;
    }

    .scl--jd-btn-hea-st{
        width: 100%;
        height: 52px;
        border-radius: 30px;
    }

    .scl--jhhs-des-sty{
        width: 100%;
    }

    .scl--jd-btn-hea-st span{
        font-size: 24px;
    }

    .scl--jhbs-pad-cons-bo-stl {
        padding-left: var(--global-mobile-padding-left);
        padding-right: var(--global-mobile-padding-left);
    }

    .scl--jdms-bo-con-wid-st{
        padding-left: var(--global-mobile-padding-left);
        padding-right: var(--global-mobile-padding-left);
        gap: 35px;
    }

    .scl--jcbs-sub-app-bo-con-st{
        padding-left: var(--global-mobile-padding-left);
        padding-right: var(--global-mobile-padding-left);
    }

    .scl--jemds-ti-tex-st{
        font-size: 34px;
    }

    .scl--jemds-par-tex-st{
        font-size: 24px;
    }

    .scl--jdms-eac-met-da-st ul li{
        font-size: 24px;
        padding: 0px;
    }

    .scl--jdms-eac-met-da-st li::before{
        font-size: 20px;
        top: 30%;
    }

    .scl--jds-tim-loc-st span{
        font-size: 12px;
    }

}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/job-detail/css/jobDetailSm.css"],"names":[],"mappings":"AAAA;IACI;QACI,YAAY;QACZ,oBAAoB;QACpB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,aAAa;QACb,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,+CAA+C;QAC/C,gDAAgD;IACpD;;IAEA;QACI,+CAA+C;QAC/C,gDAAgD;QAChD,SAAS;IACb;;IAEA;QACI,+CAA+C;QAC/C,gDAAgD;IACpD;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;AAEJ","sourcesContent":["@media (max-width: 500px) {\n    .scl--jcbst-hea-bo-st{\n        height: auto;\n        padding-bottom: 50px;\n        margin-top: 120px;\n    }\n\n    .scl--jhhs-des-sty h5{\n        font-size: 34px;\n        display: flex;\n        align-items: center;\n        min-height: 70px;\n    }\n\n    .scl--jhbs-her-hea-st{\n        flex-direction: column;\n        gap: 30px;\n    }\n\n    .scl--jhhs-but-sty{\n        width: 100%;\n        justify-content: center;\n    }\n\n    .scl--jd-btn-hea-st{\n        width: 100%;\n        height: 52px;\n        border-radius: 30px;\n    }\n\n    .scl--jhhs-des-sty{\n        width: 100%;\n    }\n\n    .scl--jd-btn-hea-st span{\n        font-size: 24px;\n    }\n\n    .scl--jhbs-pad-cons-bo-stl {\n        padding-left: var(--global-mobile-padding-left);\n        padding-right: var(--global-mobile-padding-left);\n    }\n\n    .scl--jdms-bo-con-wid-st{\n        padding-left: var(--global-mobile-padding-left);\n        padding-right: var(--global-mobile-padding-left);\n        gap: 35px;\n    }\n\n    .scl--jcbs-sub-app-bo-con-st{\n        padding-left: var(--global-mobile-padding-left);\n        padding-right: var(--global-mobile-padding-left);\n    }\n\n    .scl--jemds-ti-tex-st{\n        font-size: 34px;\n    }\n\n    .scl--jemds-par-tex-st{\n        font-size: 24px;\n    }\n\n    .scl--jdms-eac-met-da-st ul li{\n        font-size: 24px;\n        padding: 0px;\n    }\n\n    .scl--jdms-eac-met-da-st li::before{\n        font-size: 20px;\n        top: 30%;\n    }\n\n    .scl--jds-tim-loc-st span{\n        font-size: 12px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
